module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0088.jpg?v=0b040913";